// extracted by mini-css-extract-plugin
module.exports = {"btn":"linkbtn_btn__1_y3x"};